var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgErrModal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z",
    fill: "#F84960"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.3805 26.9749C58.7473 25.608 58.7473 23.392 57.3805 22.0251C56.0136 20.6583 53.7976 20.6583 52.4307 22.0251L39.3494 35.1064L26.9752 22.7322C25.6084 21.3654 23.3923 21.3654 22.0255 22.7322C20.6586 24.099 20.6586 26.3151 22.0255 27.6819L34.3997 40.0562L22.0251 52.4307C20.6583 53.7976 20.6583 56.0136 22.0251 57.3805C23.392 58.7473 25.608 58.7473 26.9749 57.3805L39.3494 45.0059L52.4311 58.0875C53.7979 59.4544 56.014 59.4544 57.3808 58.0875C58.7477 56.7207 58.7477 54.5046 57.3808 53.1378L44.2992 40.0562L57.3805 26.9749Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrModal);
export default __webpack_public_path__ + "static/media/err_modal.eda3d635bbbcba5e8b95d9a07c58ec3c.svg";
export { ForwardRef as ReactComponent };